import * as Types from '../../../graphql.d';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type ComparatorRivalsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type ComparatorRivalsQuery = { __typename?: 'query_root', comparatorRivals?: Types.Maybe<{ __typename?: 'ComparatorRivalEntityResponseCollection', data: Array<{ __typename?: 'ComparatorRivalEntity', attributes?: Types.Maybe<{ __typename?: 'ComparatorRival', rivalA?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }>, rivalB?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }>, winner?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntityResponse', data?: Types.Maybe<{ __typename?: 'SmartphoneFamilyEntity', attributes?: Types.Maybe<{ __typename?: 'SmartphoneFamily', slug: string }> }> }>, highlights?: Types.Maybe<Array<Types.Maybe<{ __typename?: 'ComponentComparatorWinnerHighlight', name: string, text: string }>>> }> }> }> };


export const ComparatorRivalsDocument = gql`
    query comparatorRivals {
  comparatorRivals {
    data {
      attributes {
        rivalA {
          data {
            attributes {
              slug
            }
          }
        }
        rivalB {
          data {
            attributes {
              slug
            }
          }
        }
        winner {
          data {
            attributes {
              slug
            }
          }
        }
        highlights {
          name
          text
        }
      }
    }
  }
}
    `;
export function useComparatorRivalsQuery(baseOptions?: Apollo.QueryHookOptions<ComparatorRivalsQuery, ComparatorRivalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ComparatorRivalsQuery, ComparatorRivalsQueryVariables>(ComparatorRivalsDocument, options);
      }
export function useComparatorRivalsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ComparatorRivalsQuery, ComparatorRivalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ComparatorRivalsQuery, ComparatorRivalsQueryVariables>(ComparatorRivalsDocument, options);
        }
export type ComparatorRivalsQueryHookResult = ReturnType<typeof useComparatorRivalsQuery>;
export type ComparatorRivalsLazyQueryHookResult = ReturnType<typeof useComparatorRivalsLazyQuery>;
export type ComparatorRivalsQueryResult = Apollo.QueryResult<ComparatorRivalsQuery, ComparatorRivalsQueryVariables>;